// extracted by mini-css-extract-plugin
module.exports = {"isGreen":"CheckIconComponent_isGreen__36gth"};